import { lazy, Suspense } from 'react';

import { createBrowserRouter, Navigate } from 'react-router-dom';

import RootLayout from '@/layouts/RootLayout';
import HomePage from '@/pages/HomePage';
import LoginPage from '@/pages/Login/LoginPage';
import NotFoundPage from '@/pages/NotFoundPage';

import { PrivateRoutes } from './PrivateRoutes';
import { RouterSuspenseFallback } from './RouterSuspenseFallback';

const FfneListPage = lazy(() => import('@/pages/Ffne/index'));
const FfneDetailsPage = lazy(() => import('@/pages/Ffne/FfneDetails'));

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
    errorElement: <NotFoundPage />,
  },
  {
    path: '/',
    element: <PrivateRoutes />,
    errorElement: <NotFoundPage />,
    children: [
      {
        element: <RootLayout />,
        children: [
          {
            index: true,
            element: <Navigate to="/home" replace />,
          },
          {
            path: 'home',
            element: <HomePage />,
          },
          {
            path: 'projects/:id/ffne',
            element: (
              <Suspense fallback={<RouterSuspenseFallback />}>
                <FfneListPage />
              </Suspense>
            ),
          },
          {
            path: 'projects/:id/ffne/:ffneId',
            element: (
              <Suspense fallback={<RouterSuspenseFallback />}>
                <FfneDetailsPage />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
]);
